import React from 'react';
import './App.css';
import Landing from './views/Landing'
import Products from './views/Products'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  return (
    <Router>
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/products" element={<Products />} />
        </Routes>
    </Router>
  );
}

export default App;
